import Utils from '../utils';



// refresh captcha
document.addEventListener('click', async (ev) => {
    const target = ev.target as HTMLElement;
    if (target && target.id === 'getCaptcha') {
        await Utils.getNewCaptcha('changepwd/utils');
    }
});

// Submit unlockSearch form
document.addEventListener('submit', async (ev) => {
    const form = ev.target as HTMLFormElement;
    if (form && form.id === 'changepwdSearch') {
        ev.preventDefault();
        Utils.setOverlay(true); 
        try {
            const data = Utils.getData(ev);
            const response = await Utils.emit <{url: string}>({ url: '/changepwd', data });
            if (response.url) window.location.href = '/changepwd/changepwdrta';
            
        } finally {
            Utils.setOverlay(false); 
        }
    }
});


